import { atom } from 'jotai'

import { QuoteAnalytics } from './types'

export const quoteAnalyticsData = atom<QuoteAnalytics>()

export const uniqueViewersCountAtom = atom(get => {
  const uniqueViewers = get(quoteAnalyticsData)?.uniqueViewers ?? []
  return uniqueViewers.length
})

export const uniqueViewersAtom = atom(
  get => get(quoteAnalyticsData)?.uniqueViewers ?? []
)

export const viewsByDayAtom = atom(
  get => get(quoteAnalyticsData)?.viewsByDay ?? []
)

export const totalViewsCountAtom = atom(
  get => get(quoteAnalyticsData)?.totalViews ?? 0
)
